import { Box, Container } from '@mui/material';
import GitBookLink from '@/components/helpcenter/GitBookLink';
import { PBreadcrumbs } from '@/components/molecules/Breadcrumbs/PBreadcrumbs';
import Notifications from '@/components/notifications/Notifications';
import { HEADER } from '@/config';
import { useBreadcrumbs } from './hooks/useBreadcrumbs';

export function TopBar() {
  const links = useBreadcrumbs();

  return (
    <Container
      maxWidth="lg"
      sx={{
        mb: `${HEADER.HEIGHT - 44}px`,
        width: '100%',
        mt: 2,
        height: 40,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        // Offset breadcrumbs below lg breakpoint to clear the hamburger menu
        pl: { xs: 10, lg: 3 },
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <PBreadcrumbs links={links} />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
        <GitBookLink deep />
        <Notifications />
      </Box>
    </Container>
  );
}
